/**
 * @generated SignedSource<<df139ed8cf5fb1f2ad1ed1d035276bf2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EcommerceSettingsInput = {
  accessKey?: string | null;
  accessSecret?: string | null;
  adminPath?: string | null;
  apiKey?: string | null;
  apiSecret?: string | null;
  currencyGlobalID?: string | null;
  ecommerceGlobalID: string;
  productsApi?: string | null;
  recaptchaToken: string;
  remoteUrl?: string | null;
  salesChannelID?: string | null;
  siteId?: string | null;
};
export type storeUrlSalesChannelDialogSaveMutation$variables = {
  input: EcommerceSettingsInput;
};
export type storeUrlSalesChannelDialogSaveMutation$data = {
  readonly saveEcommerceSettings: {
    readonly ecommerceID: number;
  } | null;
};
export type storeUrlSalesChannelDialogSaveMutation = {
  response: storeUrlSalesChannelDialogSaveMutation$data;
  variables: storeUrlSalesChannelDialogSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "settingsInput",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "storeUrlSalesChannelDialogSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "saveEcommerceSettings",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "storeUrlSalesChannelDialogSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "saveEcommerceSettings",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "502bd3f0eeb3f445cedb925bb9fe009d",
    "id": null,
    "metadata": {},
    "name": "storeUrlSalesChannelDialogSaveMutation",
    "operationKind": "mutation",
    "text": "mutation storeUrlSalesChannelDialogSaveMutation(\n  $input: EcommerceSettingsInput!\n) {\n  saveEcommerceSettings(settingsInput: $input) {\n    ecommerceID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3ccb9c589464f760b09fb26750f8645";

export default node;
